var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show_documentation || _vm.forceShow)?_c('a',{attrs:{"href":_vm.href,"target":"_blank","rel":"noopener noreferrer"}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }